import {
	DATA_SUMMARY_SECTION_I18N_KEYS
} from '../../../../../features/topics/components/constants/i18n/DataSummarySectioni18nConstants';

export const DATA_SUMMARY_SECTION_I18N_EN = {
	[DATA_SUMMARY_SECTION_I18N_KEYS.file_name]:                     "File name:",
	[DATA_SUMMARY_SECTION_I18N_KEYS.file_size]:                     "File size:",
	[DATA_SUMMARY_SECTION_I18N_KEYS.kb_label]:                      "{{fileSizeInKB}} KB",
	[DATA_SUMMARY_SECTION_I18N_KEYS.columns]:                       "Columns:",
	[DATA_SUMMARY_SECTION_I18N_KEYS.total_data_points]:             "Total data points:",
	[DATA_SUMMARY_SECTION_I18N_KEYS.includes_missing_data_remarks]: "Including rows with missing data",
	[DATA_SUMMARY_SECTION_I18N_KEYS.no_source_remarks]:             "No source column detected. File name will be used as the source in the database.",
	[DATA_SUMMARY_SECTION_I18N_KEYS.no_relevant_columns_detected_remarks]: "No relevant columns detected",
	[DATA_SUMMARY_SECTION_I18N_KEYS.no_content_column_detected_remarks]:   "No content column detected",
	[DATA_SUMMARY_SECTION_I18N_KEYS.date_for_all_data_points]:             "Date for all data points:",
	[DATA_SUMMARY_SECTION_I18N_KEYS.no_date_column_detected_remarks]:      "No date column detected. Please set a date to apply to all uploaded content",
	[DATA_SUMMARY_SECTION_I18N_KEYS.language]:							   "Language",
	[DATA_SUMMARY_SECTION_I18N_KEYS.file_size_exceeded_message]:           " | File size is greater than 50 MB. Please choose another file.",
	[DATA_SUMMARY_SECTION_I18N_KEYS.rows_exceeded_message]:                " | There are more than 100,000 data points. Please choose another file."
};


// WEBPACK FOOTER //
// ./src/locales/en/features/topics/components/data_summary_section.i18n.en.js